import * as React from 'react';
import { SVGProps } from 'react';
const SvgCartMenos = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33 33" {...props}>
    <g>
      <g data-name="fondo cantidad">
        <g data-name="Trazado 277">
          <path
            data-name="Trazado 34113"
            d="M16.5 1a66.839 66.839 0 0 0-8.96.39c-2.13.32-3.49.86-4.39 1.77a7.549 7.549 0 0 0-1.77 4.39 65.018 65.018 0 0 0-.39 8.96 66.75 66.75 0 0 0 .39 8.96c.32 2.13.86 3.49 1.77 4.39a7.549 7.549 0 0 0 4.39 1.77 65.018 65.018 0 0 0 8.96.39 66.75 66.75 0 0 0 8.96-.39c2.13-.32 3.49-.86 4.39-1.77a7.549 7.549 0 0 0 1.77-4.39 65.018 65.018 0 0 0 .39-8.96 66.75 66.75 0 0 0-.39-8.96c-.32-2.13-.86-3.49-1.77-4.39a7.549 7.549 0 0 0-4.39-1.77A65.018 65.018 0 0 0 16.5 1m0-1C31.97 0 33 1.03 33 16.5S31.97 33 16.5 33 0 31.97 0 16.5 1.03 0 16.5 0Z"
            fill="#8ab934"
          />
        </g>
      </g>
      <path
        data-name="Uni\xF3n 10"
        d="M9.93 17.91a1.411 1.411 0 0 1 0-2.82h13.14a1.411 1.411 0 0 1 0 2.82H9.93Z"
        fill="#163344"
      />
    </g>
  </svg>
);
export default SvgCartMenos;
